import { useQuery } from '@tanstack/react-query'
import type { AirportWeather, WeatherAirport } from '@jupi/shared'
import { api } from '@jupi/ui'

export const weatherKeys = {
  airports: ['weather', 'airports'] as const,
  airport: (icao: string) => ['weather', 'airport', icao] as const,
}

export function useWeatherAirports() {
  return useQuery({
    queryKey: weatherKeys.airports,
    queryFn: () => api.get<{ airports: WeatherAirport[] }>('/api/weather/airports').then((r) => r.airports),
    staleTime: 60 * 60_000,
  })
}

export function useAirportWeather(icao: string) {
  return useQuery({
    queryKey: weatherKeys.airport(icao),
    queryFn: () => api.get<AirportWeather>(`/api/weather/airports/${encodeURIComponent(icao)}`),
    refetchInterval: 60_000,
    staleTime: 30_000,
  })
}
